//3rd Party Components
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import AUbutton from '@gov.au/buttons';
import AUselect from '@gov.au/select';
import AUpageAlert from '@gov.au/page-alerts';
import { AUcallout } from '@gov.au/callout';
import { useState } from 'react';
import { useHistory } from "react-router-dom";
import axios from 'axios';
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

//Components
import CASASpinner from '../Portal/CASASpinner';
import CasaModal from '../CASA/CasaModal';

//Actions
import { DeRegisterDrone, FETCH_DEREGISTERDRONE_SUCCESS } from '../../PortalStore/Actions/DeRegisterDroneActions';
import { addPageAlert } from '../../PortalStore/Actions/PageAlertActions';

const RPADetails = ({ droneRegId, droneId, drone, organisationId, expiryMsg, from, B2CSettings, apps, draftRPAs }) => {
    let history = useHistory();
    let dispatch = useDispatch();

    let standalone = useSelector(state => state.B2CSettings.items.standalone);

    const [modal, setModal] = useState(false);
    const [deregerror, setDeregerror] = useState(false);
    const [showSpinnerFlag, setShowSpinnerFlag] = useState(false);
    const [selectedWeightClassCode, setSelectedWeightClassCode] = useState('')
    const [selectedWeightClassValue, setSelectedWeightClassValue] = useState('')
    const [showWeightClassSelector, setShowWeightClassSelector] = useState(false);
    const [weightClassUpdated, setWeightClassUpdated] = useState(false);

    const toggle = () => {
        setModal(!modal);
    }

    let sethrefRenew = "";
    let sethrefRenewAll = "";
    let paramsRenew = {};
    paramsRenew.droneId = droneId;
    paramsRenew.droneRegId = droneRegId;
    paramsRenew.organisationId = organisationId;
    paramsRenew.selectedWeightClassCode = selectedWeightClassCode;
    paramsRenew.selectedWeightClassValue = selectedWeightClassValue;

    let paramsRenewAll = {}
    paramsRenewAll.droneRegId = droneRegId;
    paramsRenewAll.organisationId = organisationId;
    paramsRenewAll.selectedWeightClassCode = selectedWeightClassCode;
    paramsRenewAll.selectedWeightClassValue = selectedWeightClassValue;
    paramsRenewAll.renewAll = true;

    if (organisationId !== "") {
        paramsRenew.from = "org";
        sethrefRenew = `/organisation/${organisationId}/drone-renewal` + "?standalone=" + standalone + "&params=" + encodeURIComponent(btoa(JSON.stringify(paramsRenew)));
        sethrefRenewAll = weightClassUpdated? '/dronesreneworg' + "?weightClassUpdated=1" + "&standalone=" + standalone + "&params=" + encodeURIComponent(btoa(JSON.stringify(paramsRenewAll)))
        : '/dronesreneworg' + "?standalone=" + standalone + "&params=" + encodeURIComponent(btoa(JSON.stringify(paramsRenewAll)));
    }
    else {
        paramsRenew.from = "ind";
        sethrefRenew = '/drone-renewal' + "?standalone=" + standalone + "&params=" + encodeURIComponent(btoa(JSON.stringify(paramsRenew)));;
        sethrefRenewAll = weightClassUpdated? '/dronesrenewind' + "?weightClassUpdated=1" + "&standalone=" + standalone + "&params=" + encodeURIComponent(btoa(JSON.stringify(paramsRenewAll)))
        : '/dronesrenewind' + "?standalone=" + standalone + "&params=" + encodeURIComponent(btoa(JSON.stringify(paramsRenewAll)));
    }

    //display rules
    // renew -
    //     no draft reg app
    //     no renewals in progress
    //     has one or more drones with an expiry date within 30 days of todays date (past or future)
    let showRenewButton = false;

    if (expiryMsg === "Expiring soon" || expiryMsg === "Expired") {
        showRenewButton = true;
    }

    if (draftRPAs && draftRPAs.length > 0) {
        showRenewButton = false;
    }

    let jparams = {
        from: from,
        organisationId: organisationId
    }

    const deregister = () => {
        if (deregerror) return;

        toggle();

        setShowSpinnerFlag(true);
        const webappurl = B2CSettings.items.webappurlPortalApi;
        const accessToken = B2CSettings.items.accesstokenPortal;
        const standalone = B2CSettings.items.standalone;

        //dispatch deregister action
        axios.all([
            dispatch(DeRegisterDrone(webappurl, accessToken, droneId, organisationId)),
        ])
            .then(axios.spread((dronesres) => {
                if (dronesres.type === FETCH_DEREGISTERDRONE_SUCCESS) {
                    setTimeout(function () {
                        setShowSpinnerFlag(false);

                        if (organisationId !== "") {
                            history.push("/orgmanagerpa?dronedereged=1&standalone=" + standalone + "&params=" + encodeURIComponent(btoa(JSON.stringify(jparams))));
                        } else {
                            if (from === "ind") {
                                history.push("/indmanagerpa?dronedereged=1&standalone=" + standalone + "&params=" + encodeURIComponent(btoa(JSON.stringify(jparams))));
                            } else {
                                history.push("/error?code=4.1&standalone=" + standalone);
                            }
                        }
                    }, 3000);
                }
                else {
                    setDeregerror(true);
                    setShowSpinnerFlag(false);

                    let msg = "We're sorry. Something has gone wrong. Try again. If the error persists contact the CASA Help Desk.";
                    let details = "Details: DRD.1";
                    dispatch(addPageAlert({ level: "error", title: msg, message: details }));
                }
            }))
            .catch(function () {
                setDeregerror(true);
                setShowSpinnerFlag(false);

                let msg = "We're sorry. Something has gone wrong. Try again. If the error persists contact the CASA Help Desk.";
                let details = "Details: DRD.2";
                dispatch(addPageAlert({ level: "error", title: msg, message: details }));
            });
    }

    const showSpinner = () => {
        if (showSpinnerFlag) {
            return (<CASASpinner message="Working. Please wait....." />)
        }
        else {
            return null;
        }
    }

    const dronesRenewalInProgMsg = () => {
        if (apps && apps.items && apps.items.inprogrenewaldrones && apps.items.inprogrenewaldrones.length > 0) {
            return (
                <AUpageAlert as="info">
                    <h3>Drone registration application processing</h3>
                    <p>
                        Please note we are still processing a drone registration application. Once complete you will see your renewed registration details below and an updated registration certificate
                        </p>
                </AUpageAlert>
            );
        }
        else {
            return null;
        }

    }

    const dronesExpiredMsg = () => {
        if (expiryMsg === "Expired") {
            return (
                <AUpageAlert as="info">
                    <h3>Expired drone registration warning</h3>
                    <p>
                        This drones&apos; registration has expired. These drones <b>cannot be legally operated</b> until they have been registered again. You can do this by selecting &apos;Renew drones&apos; below.
                        You have <b>30 days</b> after expiry to renew these drones before they are removed from myCASA.
                    </p>
                </AUpageAlert>
            );
        }
        else {
            return null;
        }
    }

    const getSelectedValue = (e) => {
        const selectedOption = drone.weightClassList.find(option => option.casa_code === e.target.value)

        setSelectedWeightClassCode(selectedOption?.casa_code ?? "")
        setSelectedWeightClassValue(selectedOption?.casa_name ?? "")

        setWeightClassUpdated(true)
    }

    const showSelector = (e) => {
        e.preventDefault()
        setShowWeightClassSelector(true)
    }

    const getOptions = () => {

        if (!drone.weightClassList) {
            return null
        }
       
        let selectOptions = [{ value: "", text: 'Only select if assigned weight class is incorrect', enccode: "" }]
        if (!drone.suggestedWeightClassValue) {
            selectOptions = [{ value: "", text: 'Please select a weight class', enccode: "" }]
        }

        const referenceData = drone.weightClassList.map(item => {
            return {
                value: item.casa_code,
                text: item.casa_name,
                enccode: item.enccode,
                refdatatype: item.casa_type
            }
        })

        return selectOptions.concat(referenceData)
    }

    return (
        <Fragment>
            {dronesRenewalInProgMsg()}

            {dronesExpiredMsg()}

            {drone.isRegisteredOverseas &&
                <AUcallout title=''>
                    Any drone with foreign registration is still permitted to legally fly in Australia within the standard operating conditions of registration, although it will still continue to be registered in another country.
                </AUcallout>
            }
            {showRenewButton &&
                <AUcallout
                    title="New weight class requirements"
                    srOnlyTitle
                    style={{ maxWidth: `34.5em` }}>
                    <Fragment>
                        <p>From July 27th 2021 CASA requires the weight class for all registered drones. Please ensure all weight classes against your registered drones are correct.</p>
                    </Fragment>
                </AUcallout>}

            <div className="au-form-group">
                <h3>Manufacturer</h3>
                <span>{drone.manufacturer}</span>
                {drone.model &&
                    <Fragment>
                        <h3>Model</h3>
                        <span>{drone.model}</span>
                    </Fragment>}
                {drone.serialNumber &&
                    <Fragment>
                        <h3>Serial number / registration mark</h3>
                        <span>{drone.serialNumber}</span>
                    </Fragment>}
                {drone.category &&
                    <Fragment>
                        <h3>Category</h3>
                        <span>{drone.category}</span>
                    </Fragment>}
                {drone.category === 'Airship' &&
                    <AUcallout
                        title=""
                        srOnlyTitle
                        style={{ maxWidth: `34.5em` }}>
                        <Fragment>
                            <p>A remotely piloted airship with an envelope capacity of not more than 100 m<sup>3</sup> is a medium RPA.
                                    The registration fee for the airship is the same as an RPA with a gross weight of more than 25 kg, but not more than 150 kg.</p>
                            <p>If your remotely piloted airship has an envelope capacity of more than 100 m<sup>3</sup>, you are required to register it as a&nbsp;
                                    <a href="https://www.casa.gov.au/aircraft/civil-aircraft-register/aircraft-registration">VH Registered Aircraft</a>.</p>
                        </Fragment>
                    </AUcallout>}
                {showRenewButton && drone?.manufacturedWeight > 0 &&
                    <Fragment>
                        <h3>Manufactured weight</h3>
                        <span>{drone.manufacturedWeight < 1000 ? `${drone.manufacturedWeight} g` : `${drone.manufacturedWeight / 1000} kg`}</span>                        
                    </Fragment>}                
                {showRenewButton && drone.suggestedWeightClassValue &&
                    <Fragment>
                        <h3>Weight class</h3>
                    <span>{drone.suggestedWeightClassValue}</span>
                    </Fragment>}
                {showRenewButton && drone.suggestedWeightClassValue && drone?.weightClassList.length > 0 &&
                    <Fragment>
                        <AUcallout
                            title="Important"
                            srOnlyTitle
                            style={{ maxWidth: `34.5em` }}>
                            <Fragment>
                                <p>We have assigned a weight class based on the manufactured weight of your drone. The weight class must include all components, fuel, and modifications such as cameras or gimbals.
                                    <br /><br />
                                    If this is incorrect please <a href="#" onClick={showSelector}>update the weight class of this drone</a>.
                                </p>
                            </Fragment>
                        </AUcallout>
                    </Fragment>}
                {showRenewButton && !drone.suggestedWeightClassValue && drone?.weightClassList.length > 0 &&
                    <Fragment>
                        <AUcallout
                            title="Important"
                            srOnlyTitle
                            style={{ maxWidth: `34.5em` }}>
                            <Fragment>
                                <p>A weight class based on the manufactured weight of your drone is required. The weight class must include all components, fuel, and modifications such as cameras or gimbals.
                                    <br /><br />
                                    <a href="#" onClick={showSelector}>Update the weight class of this drone</a>.
                                </p>
                            </Fragment>
                        </AUcallout>
                    </Fragment>}
                {showRenewButton && showWeightClassSelector &&
                    <Fragment>
                        <AUselect
                            options={getOptions()}
                            onChange={getSelectedValue}
                        />
                        <br /><br />
                        <Link
                            id="renew3"
                            className="au-btn au-btn--darker"
                            to={sethrefRenewAll}>
                            <span>
                                Save and continue
                            </span>
                            <br />
                        </Link>
                    </Fragment>}
                {!showRenewButton && showWeightClassSelector &&
                    <Fragment>
                        <h3>Weight class</h3>
                        <span>{drone.weightClass}</span>
                    </Fragment>}
                <h3>Registration type</h3>
                <span>{drone.regtype} </span>
                <h3>Expiry date</h3>
                <span>{drone.expirydate}</span>
                {expiryMsg === "Expired" ?
                    <span className="badge badge-error m-b-1">{expiryMsg}</span>
                    :
                    <span className="badge badge-warning m-b-1">{expiryMsg}</span>
                }
                <br />
                <br />
                <AUbutton className="au-btn au-btn--darker btn-Hollow" onClick={toggle}>Deregister</AUbutton>
            &nbsp;&nbsp;
            {showRenewButton ? <Link
                    id="renew2"
                    className="au-btn au-btn--darker"
                    to={sethrefRenew}>

                    <span>
                        Renew
                    </span>

                    <br />
                </Link> : null}

                <br />

                <CasaModal
                    heading="Deregister Drone"
                    toggle={toggle}
                    active={modal}
                    action={deregister}>
                    <Fragment>
                        Are you sure you want to deregister your Drone?
                        <br />
                        <h3>Manufacturer and model</h3>
                        <span>{drone.manufacturer} {drone.model}</span>
                        <h3>Serial number / registration mark</h3>
                        <span>{drone.serialNumber}</span>
                        <h3>Weight class</h3>
                        <span>{drone.weightClass}</span>
                        <h3>Registration type</h3>
                        <span>{drone.regtype}</span>
                        <h3>Expiry date</h3>
                        <span>{drone.expirydate}</span>
                        <h5>This cannot be undone.</h5>
                        <br />
                    </Fragment>
                </CasaModal>

                {showSpinner()}

            </div>
        </Fragment>

    )
};

RPADetails.propTypes = {
    droneId: PropTypes.string.isRequired,
    droneRegId: PropTypes.string.isRequired,
    expiryMsg: PropTypes.string.isRequired,
    from: PropTypes.string.isRequired,
    organisationId: PropTypes.string,
    apps: PropTypes.object,
    draftRPAs: PropTypes.array,
    B2CSettings: PropTypes.object,
    drone: PropTypes.object.isRequired
};

RPADetails.defaultProps = {
    organisationId: ""
};

export default RPADetails;
